import { getMe } from 'platform-components/src/components/user/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentTeamLevel } from 'common.components/user/selectors';
import { getSubjects } from 'store/courses/selectors';

import SubjectsNavList from './__list/subjects-nav__list';
import { getCourseSubject } from './selectors';

interface Props {
    teamId: number;
    currentSubject: string;
    disabled?: boolean;
    metrikaParams: Record<string, any>;
    mix?: string;
    onSelect: (subject: string) => void;
    shouldShowOnlyCurrentSubject?: boolean;
}

export const SubjectsNav = (props: Props) => {
    const { currentSubject, shouldShowOnlyCurrentSubject, teamId } = props;

    const me = useSelector(getMe);
    const teamLevel = useSelector((storeState) => getCurrentTeamLevel(storeState, { classId: teamId }));

    const allCoursesSubjects = useSelector((storeState) => getSubjects(storeState, { classId: teamId }));
    const currentCourseSubject = useSelector((storeState) =>
        getCourseSubject(storeState, { classId: teamId, subject: currentSubject })
    );
    const currentCourseSubjects = currentCourseSubject ? [currentCourseSubject] : [];

    const subjects = shouldShowOnlyCurrentSubject ? currentCourseSubjects : allCoursesSubjects;

    return (
        <SubjectsNavList
            currentSubject={props.currentSubject}
            me={me}
            metrikaParams={props.metrikaParams}
            onSelect={props.onSelect}
            subjects={subjects}
            teamLevel={teamLevel}
        />
    );
};

export default SubjectsNav;
